import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e24334d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-profile-page" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-info",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center text-muted py-10" }, " Time não encontrado. ", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between mb-6" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-60px me-4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fw-bold mb-1" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = { class: "text-muted mb-0" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "fw-bold fs-2 text-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "pontos", -1))
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Membros")
], -1))
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "symbol symbol-40px me-3" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  class: "badge badge-light-info ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!_ctx.group)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.group.icon_path || '/media/avatars/blank.png',
                    alt: ""
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.group.tag), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.group.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    (_ctx.flagUrl(_ctx.group.country))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.flagUrl(_ctx.group.country),
                          class: "country-flag me-1",
                          alt: ""
                        }, null, 8, _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.countryName(_ctx.group.country)) + " · " + _toDisplayString(_ctx.group.members_count) + " membros ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.group.points), 1),
                _hoisted_18
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.members, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: "d-flex align-items-center border-bottom py-3"
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: m.profile_photo_path || '/media/avatars/blank.png',
                        alt: ""
                      }, null, 8, _hoisted_23)
                    ]),
                    _createVNode(_component_router_link, {
                      to: `/profile/user/${m.id}`,
                      class: "fw-bold text-reset"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(m.nick || m.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (m.group_role === 'captain')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Capitão "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ], 64))
  ]))
}